module.exports = __webpack_public_path__ + "static/media/New_York_Islanders.bb4cd93e.svg";